import { render } from "./sweetAlert.vue?vue&type=template&id=fac70740"
import script from "./sweetAlert.vue?vue&type=script&lang=js"
export * from "./sweetAlert.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__